
export const WEB_COLORS = {
  primary: "#004135",
  secondary: "#47EE40", 
  pale: "#EDFFE8",
  orange: "#FA4616",
  errorColor: "#ED1C24",
  disabledColor: "#989898",
  black: "#000",
  white: "#fff",
  grey: "#808080",
  lightGrey: "#F5F5F5",
  blue: "#407BEF",
  textFadeColor: "rgba(0, 0, 0, 0.38)",
  fadeColor: "#727272",
  darkTeal: "#004135",
  paleSkyBlue: "#f7fafa",
  lightSkyBlue: "#e5f1f1",
  mainColorShade2: "#4D6767",
  paleGreen: "#E9FFE6",
  black: "#1F1F1F",
  shadedBlack: "#1F1F1FCC",
  lightShade1: "#3F3F3FCC",
  lightGreenShade: "#e5f1f1",
  fadeColor2: "#727272",
  darkFadedText: "#3F3F3F",
  blackHeading: "#181818",
  primaryLightShade: "#00B500",
  fadedSubtext: "#646464",
  fluorescentGreen: "#00B500",
  primaryLightShade2: "#00B500",
  fadedSubtext: "#646464",
  paleGreenLight: "#DFF7EB",
};
